import { configureStore } from '@reduxjs/toolkit';
import ProcessReducer from '../Pages/Processes/reducer';
import UserReducer from '../Pages/Login/reducer';
import ReportReducer from '../Pages/Reports/ReportReducer';
import AccountReducer from '../Pages/Accounts/reducer';
import BrokerReducer from '../Pages/Brokers/reducer';
import AlgorithmsReducer from '../Pages/Algorithms/reducer';
import LiquidityMakerReducer from '../Pages/Algorithms/LiquidityMaker/reducer';
import MakerCreatorReducer from '../Pages/Algorithms/MakerCreator/reducer';
import PairReducer from '../Pages/Pairs/reducer';
import BalanceCurrencyReducer from '../Pages/BalanceCurrency/reducer';
import AccountBalancesReducer from '../Components/Account/AccountBalance/reducer';
import AccountOrdersReducer from '../Components/Orders/reducer';
import DexArbitrageReducer from '../Pages/Algorithms/DexArbitrage/reducer';
import PingPongReducer from '../Pages/Algorithms/PingPong/reducer';
import AlgorithmOrdersReducer from '../Components/Algorithm/Orders/reducer';
import VolumeMakerReducer from '../Pages/Algorithms/VolumeMaker/reducer';
import ClientsReducer from '../Pages/Clients/reducer';
import SettingsReducer from '../Pages/Settings/reducer';
import RolesAccessReducer from '../Pages/RolesAccess/reducer';
import BidAscReducer from '../Components/Algorithm/BidAsc/reducer';
import UsersReducer from '../Pages/Users/reducer';
import AuthUserReducer from '../Components/AuthUser/reducer';
import RoutesReducer from '../Components/Routes/reducer';
import RolesReducer from '../Components/Roles/reducer';
import LpvReducer from '../Pages/Algorithms/Lpv/reducer';
import DashboardReducer from '../Pages/Dashboard/reducer';
import KpiReducer from '../Components/Clients/reducer';
import PositionReducer from '../Pages/Position/reducer';
import VolumeIncreaseLiquidityMakerReducer from '../Pages/Algorithms/VolumeIncreaseLiquidityMaker/reducer';
import DashboardAlgorithmsReducer from '../Pages/Algorithm/reducer';
import LogsReducer from '../Pages/Logs/reducer';
import ESignalReducer from '../Pages/Algorithms/ESignal/reducer';
export default configureStore({
    reducer: {
        authUser: AuthUserReducer,
        routes: RoutesReducer,
        roles: RolesReducer,
        processes: ProcessReducer,
        user: UserReducer,
        report: ReportReducer,
        accounts: AccountReducer,
        accountBalances: AccountBalancesReducer,
        accountOrders: AccountOrdersReducer,
        brokers: BrokerReducer,
        algorithms: AlgorithmsReducer,
        dashboardAlgorithms: DashboardAlgorithmsReducer,
        liquidityMakers: LiquidityMakerReducer,
        dexArbitrages: DexArbitrageReducer,
        volumeMaker: VolumeMakerReducer,
        pingPongs: PingPongReducer,
        makerCreators: MakerCreatorReducer,
        lpvs: LpvReducer,
        pairs: PairReducer,
        balancesCurrency: BalanceCurrencyReducer,
        algorithmOrders: AlgorithmOrdersReducer,
        bidAsc: BidAscReducer,
        clients: ClientsReducer,
        settings: SettingsReducer,
        rolesAccess: RolesAccessReducer,
        users: UsersReducer,
        kpi: KpiReducer,
        dashboard: DashboardReducer,
        volumeIncreaseLiquidityMakers: VolumeIncreaseLiquidityMakerReducer,
        position: PositionReducer,
        logs: LogsReducer,
        eSignal: ESignalReducer
    }
});
